goog.provide('el8.app.settings.patientTags');

// goog.require('el8.app.shared.dialog.addEditDocTag');
goog.require('el8.data.patientTags');
goog.require('el8.template.app.settings.patientTags');
goog.require('el8.uiwidget.CuratedList');
goog.require('el8.util.consts');
goog.require('el8.appchart.dialog.mergePatientTags');



el8.app.settings.patientTags = (function() {
    var that;

    that = {
        init: function($container) {
            var $content = $(el8.template.app.settings.patientTags.content({
                isPracticeAdmin: el8.data.currUser.isPracticeAdmin()
            }));
            $container.html($content).show();
            setupPatientTagsList($container);
        },
        _curatedList: null
    };

    function setupPatientTagsList($container) {
        var curatedList;

        curatedList = new el8.uiwidget.CuratedList({
            entitySet: el8.data.patientTags,
            customDeleteFn: function(patientTag) {
                var confirmMsg = 'Removing this tag from your Practice Settings will not delete the tag from current patient charts.';
                var title = 'Are you sure you want to remove this patient tag?';

                el8.uiwidget.confirm(
                    confirmMsg,
                    function() {
                        el8.data.patientTags.deleteItem(patientTag);
                    },
                    null,
                    { title: title, prefHeight: 240 }
                );
            },
            customMergeFn: function(patientTag) {
                el8.appchart.dialog.mergePatientTags.show(patientTag);
            },
            customValidationFn: function(form) {
                // checking that value hasn't been already used
                var value = form.getVal('value').trim().toLowerCase();
                var tagId = form.getContainer().data('id');
                var possibleDuplicate = el8.data.patientTags.all()
                        .filter(function(patientTag) { return patientTag.getId() !== tagId; })
                        .find(function(patientTag) { return patientTag.getValue('value').toLowerCase() === value; });

                if (possibleDuplicate) {
                    el8.uiwidget.alert('Your practice already has a patient tag named "' +
                        form.getVal('value') + '." Please choose a unique name.');
                    return false;
                }
                return true;
            },
            itemDescriptionStr: 'patient tag',
            container: $('.patient-tags-section', $container),
            listSelector: '.patient-tags-list',
            sortable: false,
            listTemplateFn: function() {
                return el8.template.app.settings.patientTags.list({
                    patientTags: el8.data.patientTags.allAsSoyMaps(),
                    isPracticeAdmin: el8.data.currUser.isPracticeAdmin()
                });
            },
            formTemplateFn: function(tagId) {
                return el8.template.app.settings.patientTags.form({
                  tagId: tagId
                });
            },
            fieldSpec: [
                {
                    name: 'value',
                    selector: ':input[name="value"]',
                    infoText: 'Label',
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                    maxLength: 100,
                    validate: { required: true }
                }
            ]
        });

        that._curatedList = curatedList.init();
    }

    return that;
})();
